<template>
    <div>
        <p class="caption">Current Patient</p>
        <div class="columns is-variable is-8">
            <div class="column is-narrow">
                <p>Call Code</p>
                <p class="title">{{callCode}}</p>
            </div>
            <div class="column is-narrow">
                <p>Contact Number</p>
                <p class="title">{{tel}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "currentPatient",
        props: ['tel','callCode']
    }
</script>

<style scoped>

</style>